import RequestVerification from '@/components/auth/RequestVerification';

const RequestVerificationPage = () => {
  return <RequestVerification />;
};

export default RequestVerificationPage;